module.exports = __webpack_public_path__ + "img/1.06305c96.svg";